// src/modals/ExtraModal.jsx — modale de saisie d'une prestation extra
// (intervention maintenance, frais ponctuel, etc.) pour un logement/mois.
// Champs : libellé, montant, description optionnelle.
//
// Réutilisée aussi pour les AJUSTEMENTS (avoir, remise, parrainage — montant
// pouvant être négatif) via les props `hideDesc` / `title` / `placeholder` /
// `requireMontant`. ⚠️ CHEMIN ARGENT en mode ajustement : `requireMontant`
// désactive « Enregistrer » si `isNaN(parseFloat(montant))` pour interdire un
// 0€ silencieux qui écraserait une déduction réelle. Les défauts gardent
// l'usage « extras » existant strictement inchangé.

import { useState } from "react"
import { DS } from "../lib/ui"

import useEchapPourFermer from "../lib/useEchapPourFermer"
export default function ExtraModal({ lid, logNom, extra, onSave, onClose, hideDesc = false, title, placeholder, requireMontant = false }) {
  // Échap ferme — consigne 2026-08-14, hook partagé (pile anti-double-fermeture).
  useEchapPourFermer(onClose)

  const [label, setLabel] = useState(extra?.label || "")
  const [montant, setMontant] = useState(extra?.montant === undefined || extra?.montant === null ? "" : String(extra.montant))
  const [desc, setDesc] = useState(extra?.desc || "")
  const si = { border:`0.5px solid ${DS.borderHover}`,borderRadius:DS.radiusControl,padding:"9px 12px",width:"100%",fontSize:13,outline:"none",fontFamily:DS.fontBody,background:DS.card }
  const lbl = { fontSize:11,color:DS.textMuted,marginBottom:4,fontWeight:600,textTransform:"uppercase",letterSpacing:.5 }
  const noun = title || "une prestation"
  // Validation montant : en mode `requireMontant` (ajustement), un montant non
  // numérique bloque l'enregistrement (pas de 0€ silencieux). Hors ce mode,
  // comportement extras inchangé (le `||0` ci-dessous tolère un montant vide).
  const montantInvalid = requireMontant && isNaN(parseFloat(montant))
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:999,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
      <div className="fbz-modal-sheet" style={{background:DS.card,borderRadius:"20px 20px 0 0",padding:24,width:"100%",maxWidth:480,fontFamily:DS.fontBody}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
          <div>
            <div style={{fontFamily:DS.fontDisplay,fontWeight:600,color:DS.marineDark,fontSize:17}}>{extra ? "Modifier" : "Ajouter"} {noun}</div>
            <div style={{fontSize:11,color:DS.textMuted,marginTop:2}}>{logNom}</div>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",fontSize:24,cursor:"pointer",color:DS.textMuted,lineHeight:1}}>×</button>
        </div>
        <div style={{marginBottom:12}}><div style={lbl}>Libellé</div><input value={label} onChange={e => setLabel(e.target.value)} placeholder="Ex: Intervention maintenance" style={si} /></div>
        <div style={{marginBottom:hideDesc?20:12}}><div style={lbl}>Montant (€)</div><input type="number" value={montant} onChange={e => setMontant(e.target.value)} placeholder={placeholder || "0.00"} style={si} /></div>
        {!hideDesc && <div style={{marginBottom:20}}><div style={lbl}>Description</div><input value={desc} onChange={e => setDesc(e.target.value)} placeholder="Optionnel" style={si} /></div>}
        <div style={{display:"flex",gap:8}}>
          <button className="fbz-press" onClick={onClose} style={{flex:1,padding:12,background:DS.card,color:DS.marine,border:`0.5px solid ${DS.borderHover}`,borderRadius:DS.radiusControl,fontWeight:600,cursor:"pointer",fontFamily:DS.fontBody}}>Annuler</button>
          <button className="fbz-press" onClick={() => { if (montantInvalid) return; onSave({ id: extra?.id || null, label, montant: requireMontant ? parseFloat(montant) : (parseFloat(montant) || 0), desc }) }}
            disabled={montantInvalid}
            style={{flex:2,padding:12,background:montantInvalid?DS.border:DS.corail,color:montantInvalid?DS.textMuted:"#fff",border:"none",borderRadius:DS.radiusControl,fontWeight:700,cursor:montantInvalid?"not-allowed":"pointer",fontFamily:DS.fontBody}}>Enregistrer</button>
        </div>
      </div>
    </div>
  )
}
